import { Link } from "react-router-dom";
import logoIcon from "@/assets/logo-warmzapp.webp";

const Footer = () => (
  <footer className="border-t border-warmz-glass-border/20 py-12">
    <div className="container mx-auto px-4 md:px-8">
      <div className="flex flex-col md:flex-row items-center justify-between gap-6">
        <a href="#" className="flex items-center gap-1 font-display text-xl font-bold text-foreground">
          <img src={logoIcon} alt="" className="h-9 w-auto" />
          Warm<span className="text-primary">Zapp</span>
        </a>

        <div className="flex items-center gap-6 text-sm text-muted-foreground">
          <Link to="/privacy-policy" className="hover:text-foreground transition-colors">Política de Privacidade</Link>
          <Link to="/terms-of-use" className="hover:text-foreground transition-colors">Termos de Uso</Link>
        </div>

        <p className="text-xs text-muted-foreground">
          © 2026 WarmZapp. Todos os direitos reservados.
        </p>
      </div>
    </div>
  </footer>
);

export default Footer;
